let assignedSignInRedirect = false;

const registerErrorInRollbar = (message, detail = {}) => {
  if (
    typeof window !== 'undefined' &&
    window.Rollbar &&
    typeof window.Rollbar.error === 'function'
  ) {
    window.Rollbar.error(message, detail);
  }
};

export const documentUserStateResponseUnauthorized = (response) => {
  if (response.status !== 401) return false;
  if (!assignedSignInRedirect) {
    assignedSignInRedirect = true;
    window.location.assign('/users/sign_in');
  }
  return true;
};

export const rejectDocumentUserStateSaveResponse = async (response) => {
  if (documentUserStateResponseUnauthorized(response)) {
    const error = new Error('You need to sign in or sign up before continuing');
    error.status = 401;
    throw error;
  }

  const errorData = await response
    .json()
    .catch(() => ({ errors: ['Failed to update document user state'] }));
  registerErrorInRollbar('Failed to update document user state', { detail: errorData });
  throw new Error(errorData.errors?.[0] || 'Failed to update document user state');
};

export const resetDocumentUserStateSignInRedirect = () => {
  assignedSignInRedirect = false;
};
